import companyLogo from '../../../assets/images/company-logo.svg';
import { ChangePasswordForm } from '../../../components/forms/Forms';
import { Link } from 'react-router-dom';

const ChangePassword = () => {
  return (
    <main className='auth-page'>
      <Link to='/' className='logo'>
        <img src={companyLogo} alt='Options Tradehub' />
      </Link>
      <ChangePasswordForm />
    </main>
  );
};

export default ChangePassword;
